import Tooltip from "@common/components/Tooltip/Tooltip";
import { vars } from "@common/styles";
import styled, { css } from "styled-components";

export const Root = styled(Tooltip)`
  width: 3.2rem;
  height: 3.2rem;
  margin-right: 0.4rem;
`;

export const FilterButton = styled.button<{ $isActive: boolean; $ai?: boolean }>`
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 10px;
  background: ${vars.colors.black};
  border: 0.15rem solid ${vars.colors.grey90};
  align-items: center;
  justify-content: center;
  display: flex;
  cursor: pointer;

  :hover {
    opacity: 0.7;
  }

  ${({ $isActive, $ai }) =>
    $isActive &&
    $ai &&
    css`
      border: 0.15rem solid transparent;
      border-radius: 10px;

      background-image:
      /* inner fill (content area) */ linear-gradient(${vars.colors.black}, ${vars.colors.black}),
        /* border gradient */
          linear-gradient(91.04deg, #4fcf70 2.28%, #fad648 26.49%, #a767e5 50.69%, #12bcfe 74.9%, #44ce7b 99.11%);

      background-origin: border-box;
      background-clip: padding-box, border-box;
    `}

  ${({ $isActive, $ai }) =>
    $isActive &&
    !$ai &&
    css`
      background: #64b1fd26;
      border: 0.15rem solid #64b1fd80;

      svg path {
        stroke: #64b1fd;
      }
    `}
`;
